/* ==========================================================================
   PEPTIDES DIRECT — fable5-page.js  (v2 rebuild)
   Vanilla JS, no dependencies. Demo cart locally; real AJAX cart inside
   Shopify when F5ProductConfig provides variant ids + cartAdd route.

   Hero: Higgsfield-style drag-to-reveal (orange studio ⇄ hands/swab photo)
   with the alpha-channel vial video locked over the vial in the photos.
   The video is one continuous morph cycle:
     RETA (0.050s) → MOTS-C (1.928s) → GHK-CU (3.840s) → BPC-157 (5.751s)
     → wraps to RETA (7.579s / 7.645s duration).
   Right arrow plays the forward encode between cue points; left arrow plays
   the reversed encode. Browsers without VP9-alpha get a crossfade of
   transparent stills instead.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document.documentElement;
  doc.classList.add('pd-js');

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* ---------- config ---------- */
  var config = { products: [], cartAdd: null };
  var cfgEl = $('#F5ProductConfig');
  if (cfgEl) { try { config = JSON.parse(cfgEl.textContent); } catch (e) {} }
  var products = config.products || [];

  /* ======================================================================
     TOAST + CART
     ====================================================================== */
  var toastEl = $('.pd-toast'), toastTimer = null;
  function toast(html) {
    if (!toastEl) return;
    toastEl.innerHTML = html;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2600);
  }

  var cartCount = 0;
  var badge = $('.pd-nav__badge');
  var cartIcon = $('.pd-nav__cart');

  function paintCart(bump) {
    if (!badge) return;
    badge.textContent = cartCount;
    badge.classList.toggle('is-on', cartCount > 0);
    if (!bump) return;
    badge.classList.remove('is-bump');
    void badge.offsetWidth;
    badge.classList.add('is-bump');
  }

  function bumpCart() {
    cartCount++;
    paintCart(true);
  }

  /* Seed the badge from the real Shopify cart so a returning visitor sees the
     same count here as on every other page. Silent no-op outside Shopify. */
  (function seedCartCount() {
    var url = (window.PD_ROUTES && window.PD_ROUTES.cart) || '/cart';
    if (!/\.js($|\?)/.test(url)) url += '.js';   /* routes.cart_url has no .js */
    if (!window.fetch) return;
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || typeof c.item_count !== 'number') return;
        cartCount = c.item_count;
        paintCart(false);
      })
      .catch(function () {});
  }());

  function flyToCart(fromEl) {
    if (REDUCED || !cartIcon || !fromEl) return;
    var a = fromEl.getBoundingClientRect();
    var b = cartIcon.getBoundingClientRect();
    var el = document.createElement('div');
    el.className = 'pd-fly';
    el.innerHTML = '<svg viewBox="0 0 26 38"><rect x="7" y="0" width="12" height="5" rx="1.5" fill="#B9B4AE"/><rect x="9" y="5" width="8" height="4" fill="#D8D4CF"/><path d="M5 12c0-2 1.6-3.5 3.5-3.5h9c1.9 0 3.5 1.5 3.5 3.5v21a5 5 0 0 1-5 5h-6a5 5 0 0 1-5-5z" fill="#fff" stroke="#E0DCD6"/><rect x="5" y="16" width="16" height="7" fill="#FE7D18"/></svg>';
    el.style.left = (a.left + a.width / 2 - 13) + 'px';
    el.style.top = (a.top + a.height / 2 - 19) + 'px';
    document.body.appendChild(el);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = el.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 120) + 'px) scale(.7) rotate(12deg)', opacity: 1, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15) rotate(20deg)', opacity: .4 }
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.6,1)' });
    anim.onfinish = function () { el.remove(); bumpCart(); };
  }

  function addToCart(product, fromEl) {
    if (!product) return;
    if (config.cartAdd && product.variant) {
      fetch(config.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: product.variant, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        flyToCart(fromEl);
        if (REDUCED) bumpCart();
        toast('<b>' + product.name + '</b> added to cart');
      }).catch(function () {
        toast('Could not add to cart — try again');
      });
    } else {
      flyToCart(fromEl);
      if (REDUCED) bumpCart();
      toast('<b>' + product.name + '</b> added to cart');
    }
  }

  /* ======================================================================
     NAV — scroll-linked inversion. White bar / orange writing over the
     hero; flips to orange bar / white writing once the sheet reaches the
     nav (i.e. the user has scrolled past the hero), and flips back when
     they scroll back up. Pages without a sheet keep their static skin.
     ====================================================================== */
  var nav = $('.pd-nav');
  var sheet = $('.pd-sheet');
  if (nav && sheet && nav.getAttribute('data-skin') === 'light') {
    var navSkinTick = false;
    var updateNavSkin = function () {
      navSkinTick = false;
      var sheetTop = sheet.getBoundingClientRect().top;
      var navBottom = nav.getBoundingClientRect().bottom;
      var want = sheetTop <= navBottom ? 'brand' : 'light';
      if (nav.getAttribute('data-skin') !== want) nav.setAttribute('data-skin', want);
      /* once the sheet fully covers the pinned hero (past the rounded
         corners), hide the hero so the browser stops painting it */
      if (hero) hero.classList.toggle('is-covered', sheetTop <= -48);
    };
    window.addEventListener('scroll', function () {
      if (!navSkinTick) { navSkinTick = true; requestAnimationFrame(updateNavSkin); }
    }, { passive: true });
    window.addEventListener('resize', updateNavSkin);
    updateNavSkin();
  }

  /* mobile drawer */
  var burger = $('.pd-nav__burger');
  var drawer = $('.pd-drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });
  }

  /* ======================================================================
     CUSTOM CURSOR (desktop, non-reduced)
     ====================================================================== */
  if (FINE && !REDUCED) {
    doc.classList.add('pd-has-cursor');
    var dot = document.createElement('div'); dot.className = 'pd-cursor';
    var ring = document.createElement('div'); ring.className = 'pd-cursor-ring';
    document.body.appendChild(dot); document.body.appendChild(ring);
    var mx = -100, my = -100, rx = -100, ry = -100;
    window.addEventListener('pointermove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + (mx - 3.5) + 'px,' + (my - 3.5) + 'px)';
      var t = e.target;
      var hot = t.closest && t.closest('a, button, .pd-hero__grip, .pd-hero__dragzone, input');
      ring.classList.toggle('is-hot', !!hot);
    }, { passive: true });
    (function ringLoop() {
      rx += (mx - rx) * .16; ry += (my - ry) * .16;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(ringLoop);
    })();
  }

  /* ======================================================================
     HERO — cover-math registration + drag-to-reveal + vial video carousel
     ====================================================================== */
  var hero = $('.pd-hero');

  /* geometry of the source photos and of the vial inside them / the video.
     Photos are 2000×1125; vial (in both, aligned): x 506–815, y 309–956.
     Video frames are 1080×1464; vial inside: x 273–806, y 155–1299.
     VIAL box fractions (relative to the displayed photo) below include a
     ~1% oversize so the video vial fully covers the photo vial (3–6px rule). */
  var IMG_W = 2000, IMG_H = 1125;
  var VIAL_FRAC = { left: 0.17240, top: 0.17573, width: 0.31600 };
  var VID_AR = 1464 / 1080;                  /* video h/w */
  var FOCAL_X = 660 / 2000;                  /* vial centre in the photo */

  if (hero && products.length) {
    var baseImg = $('.pd-hero__base', hero);
    var wipeWrap = $('.pd-hero__wipe', hero);
    var wipeImg = $('.pd-hero__wipe .pd-hero__img', hero);
    var handle = $('.pd-hero__handle', hero);
    var grip = $('.pd-hero__grip', hero);
    var dragzone = $('.pd-hero__dragzone', hero);
    var vialBox = $('.pd-hero__vial', hero);
    var vidF = $('#PDVidF');
    var vidR = $('#PDVidR');
    var stillEl = $('.pd-hero__still', hero);
    var prevBtn = $('.pd-hero__arrow--prev', hero);
    var nextBtn = $('.pd-hero__arrow--next', hero);
    var chip = $('.pd-hero__chip', hero);
    var chipName = $('.pd-chip-name', chip);
    var chipPrice = $('.pd-chip-price', chip);
    var live = $('.pd-hero__live', hero);
    var heroAdd = $('#PDHeroAdd');
    var vialGeom = null;
    var MOBILE_MQ = window.matchMedia('(max-width: 900px)');

    /* ---------- cover-math: both photos + vial box share one transform.
       Full-bleed everywhere. Mobile keeps the vial toward the left third
       (the copy overlays the photo's plain top-right area) and pins the
       carousel arrows to the screen edges. ---------- */
    function layoutHero() {
      var isM = MOBILE_MQ.matches;
      var vw = hero.clientWidth, vh = hero.clientHeight;
      var scale = Math.max(vw / IMG_W, vh / IMG_H);
      var dw = IMG_W * scale, dh = IMG_H * scale;
      var offX = (vw - dw) / 2;
      if (dw - vw > 8) {
        var want = vw * (isM ? .268 : .5) - (isM ? FOCAL_X * dw : dw / 2);
        offX = clamp(want, vw - dw, 0);
      }
      var offY = (vh - dh) / 2;
      [baseImg, wipeImg].forEach(function (img) {
        img.style.width = dw + 'px';
        img.style.height = dh + 'px';
        img.style.transform = 'translate(' + offX + 'px,' + offY + 'px)';
      });
      /* vial video box */
      var bw = VIAL_FRAC.width * dw;
      var bh = bw * VID_AR;
      var bx = offX + VIAL_FRAC.left * dw;
      var by = offY + VIAL_FRAC.top * dh;
      vialBox.style.width = bw + 'px';
      vialBox.style.height = bh + 'px';
      vialBox.style.transform = 'translate(' + bx + 'px,' + by + 'px)';
      vialBox.style.left = '0'; vialBox.style.top = '0';
      vialGeom = { x: bx, y: by, w: bw, h: bh };
      /* arrows hug the glass edges (glass spans 25.3%–74.6% of the video
         frame); mobile: slightly below the vial's midline to clear the copy */
      var midY = by + bh * (isM ? .58 : .5);
      var glassL = bx + bw * .2528, glassR = bx + bw * .7463;
      /* mobile arrows are 24px wide — share one gap from each glass edge so
         they stay equally spaced; the gap shrinks symmetrically if the vial
         rides near the screen edge so the left arrow never clips off-screen */
      var mGap = Math.max(2, Math.min(10, glassL - 4 - 24));
      if (prevBtn) { prevBtn.style.left = (isM ? (glassL - mGap - 24) : clamp(glassL - 64, 8, vw - 54)) + 'px'; prevBtn.style.top = midY + 'px'; }
      if (nextBtn) { nextBtn.style.left = (isM ? (glassR + mGap) : clamp(glassR + 18, 8, vw - 54)) + 'px'; nextBtn.style.top = midY + 'px'; }
      /* chip sits just under the glass base (vial bottom = 88.7% of the frame);
         on mobile the vial rides left, so clamp the centred chip on-screen */
      if (chip) {
        var chipX = bx + bw / 2;
        if (isM) chipX = Math.max(chipX, chip.offsetWidth / 2 + 12);
        chip.style.left = chipX + 'px'; chip.style.top = Math.min(vh - 44, by + bh * .8873 + 12) + 'px';
      }
    }
    layoutHero();
    window.addEventListener('resize', layoutHero);
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', layoutHero);
    /* the mobile copy block reflows once fonts arrive — re-measure then */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layoutHero);
    window.addEventListener('load', layoutHero);

    /* ---------- drag-to-reveal ---------- */
    var pos = 6, target = 6;          /* % of hero width */
    var interacted = false, idleT = 0;

    function applyWipe(p) {
      wipeWrap.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      handle.style.left = p + '%';
    }
    applyWipe(pos);

    (function wipeLoop(ts) {
      /* idle-skip while the sheet covers the hero — no wipe work offscreen */
      if (!hero.classList.contains('is-covered')) {
        if (!interacted && !REDUCED) {
          idleT = ts || 0;
          target = 6 + Math.sin(idleT / 1400) * 1.8;  /* gentle idle breathe */
        }
        pos += (target - pos) * .38;                   /* glued but silky */
        if (Math.abs(target - pos) > .01) applyWipe(pos);
      }
      requestAnimationFrame(wipeLoop);
    })(0);

    function pointToPct(e) {
      var r = hero.getBoundingClientRect();
      return clamp((e.clientX - r.left) / r.width * 100, 1.5, 98.5);
    }
    function startDrag(e) {
      interacted = true;
      hero.classList.add('is-touched');
      target = pointToPct(e);
      var ring = $('.pd-cursor-ring');
      if (ring) ring.classList.add('is-grab');
      var move = function (ev) { target = pointToPct(ev); };
      var up = function () {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', up);
        if (ring) ring.classList.remove('is-grab');
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
      e.preventDefault();
    }
    grip.addEventListener('pointerdown', startDrag);
    dragzone.addEventListener('pointerdown', startDrag);
    /* keyboard access for the reveal */
    grip.setAttribute('tabindex', '0');
    grip.setAttribute('role', 'slider');
    grip.setAttribute('aria-label', 'Reveal the routine photo');
    grip.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        interacted = true; hero.classList.add('is-touched');
        target = clamp(target + (e.key === 'ArrowRight' ? 6 : -6), 1.5, 98.5);
        e.preventDefault();
      }
    });

    /* ---------- vial video carousel ---------- */
    var CUES = [0.050, 1.928, 3.840, 5.751];   /* reta, mots, ghk, bpc */
    var DUR = 7.645;
    var END_RETA = 7.579;                       /* last settled reta frame */
    var idx = 0;
    var busy = false;
    var mode = 'video';                          /* or 'stills' */
    var autoT = null;
    var hovered = false;

    function setMeta(i, announce) {
      var p = products[i];
      if (chip) {
        chip.classList.add('is-swap');
        setTimeout(function () {
          chipName.textContent = p.name + ' · ' + p.mg;
          chipPrice.textContent = p.price;
          chip.classList.remove('is-swap');
        }, 240);
      }
      if (heroAdd) heroAdd.setAttribute('data-product', p.key);
      if (announce && live) live.textContent = p.name + ' selected';
    }

    /* alpha support probe: draw a frame, check a corner pixel is transparent */
    function probeAlpha(video, cb) {
      var done = false;
      var check = function () {
        if (done) return; done = true;
        try {
          var c = document.createElement('canvas');
          c.width = 8; c.height = 8;
          var g = c.getContext('2d', { willReadFrequently: true });
          g.drawImage(video, 0, 0, 80, 80, 0, 0, 8, 8);   /* top-left corner */
          var px = g.getImageData(1, 1, 1, 1).data;
          cb(px[3] < 16);
        } catch (e) { cb(false); }
      };
      if (video.readyState >= 2) check();
      else video.addEventListener('loadeddata', check, { once: true });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 4000);
    }

    function showStill(i, instant) {
      var p = products[i];
      if (!stillEl) return;
      if (instant) {
        stillEl.src = p.still; stillEl.classList.add('is-show');
        return;
      }
      stillEl.classList.remove('is-show');
      setTimeout(function () {
        stillEl.src = p.still;
        stillEl.onload = function () { stillEl.classList.add('is-show'); };
      }, 260);
    }

    function stillsMode() {
      mode = 'stills';
      if (vidF) vidF.classList.add('is-hide');
      if (vidR) vidR.classList.add('is-hide');
      showStill(idx, true);
    }

    /* play [from → to] on `v`, then hold and call done */
    function playSeg(v, other, from, to, done) {
      var started = false;
      var kick = function () {
        v.classList.remove('is-hide');
        other.classList.add('is-hide');
        other.pause();
        v.play().then(function () { started = true; }).catch(function () { done(true); });
        (function watch() {
          if (!started) { requestAnimationFrame(watch); return; }
          if (v.currentTime >= to - 0.033 || v.ended) {
            v.pause();
            v.currentTime = to;
            done(false);
            return;
          }
          requestAnimationFrame(watch);
        })();
      };
      /* seek then go */
      var onSeek = function () { v.removeEventListener('seeked', onSeek); kick(); };
      if (Math.abs(v.currentTime - from) < 0.02) kick();
      else { v.addEventListener('seeked', onSeek); v.currentTime = from; }
    }

    function advance(dir) {
      if (busy) return;
      busy = true;
      var next = (idx + dir + products.length) % products.length;

      if (mode === 'stills') {
        showStill(next, false);
        idx = next; setMeta(idx, true);
        setTimeout(function () { busy = false; }, 620);
        return;
      }

      var finish = function (failed) {
        idx = next;
        setMeta(idx, true);
        busy = false;
        if (failed) { stillsMode(); }
      };

      if (dir > 0) {
        /* forward on vidF; wrap segment runs to the end-reta frame then snaps to cue 0 */
        var from = CUES[idx];
        var to = (next === 0) ? END_RETA : CUES[next];
        playSeg(vidF, vidR, from, to, function (failed) {
          if (!failed && next === 0) { vidF.currentTime = CUES[0]; }
          finish(failed);
        });
      } else {
        /* backward on the reversed encode: t' = DUR − t.
           Leaving reta backwards starts from the mirrored end-frame
           (reverse 0.066 ≡ forward 7.579, the settled reta pose). */
        var fromR = (idx === 0) ? (DUR - END_RETA) : (DUR - CUES[idx]);
        var toR = DUR - CUES[next];
        playSeg(vidR, vidF, fromR, toR, finish);
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { kickAuto(); advance(1); });
    if (prevBtn) prevBtn.addEventListener('click', function () { kickAuto(); advance(-1); });

    /* slow auto-advance, pauses on hover/hidden tab/reduced motion */
    function kickAuto() {
      clearInterval(autoT);
      if (REDUCED) return;
      autoT = setInterval(function () {
        if (hovered || document.hidden || busy) return;
        var r = hero.getBoundingClientRect();
        if (r.bottom < 80 || r.top > window.innerHeight - 80) return;
        advance(1);
      }, 11000);
    }
    hero.addEventListener('pointerenter', function () { hovered = true; });
    hero.addEventListener('pointerleave', function () { hovered = false; });
    kickAuto();

    /* boot the video layer.
       Both encodes are pulled into memory and served to the <video>s as blob
       URLs: blob sources are always fully seekable (servers without HTTP
       Range support clamp seeks to 0) and segment playback never stalls. */
    /* Transparent video has no single cross-browser codec:
         VP9-alpha WebM  — Chrome, Edge, Firefox, Android
         HEVC-alpha MP4  — Safari (iOS and macOS), which decodes VP9 WebM but
                           silently drops its alpha channel
       WebKit is served the MP4 first so iPhones don't download the WebM only
       to fail the alpha probe. The guess is not trusted, though: if the probe
       fails we retry the other encode before giving up on stills, so a wrong
       guess self-corrects instead of stranding the hero on stills. */
    var IS_WEBKIT = /^((?!chrome|android|crios|fxios|edgios|edg\/).)*safari/i
      .test(navigator.userAgent);

    function sourcesFor(kind) {
      var attr = kind === 'hevc' ? 'data-src-hevc' : 'data-src-webm';
      var f = vidF.getAttribute(attr), r = vidR.getAttribute(attr);
      return (f && r) ? [f, r] : null;
    }

    function bootVideos() {
      var order = IS_WEBKIT ? ['hevc', 'webm'] : ['webm', 'hevc'];

      function attempt(n) {
        var pair = n < order.length ? sourcesFor(order[n]) : null;
        if (!pair) { stillsMode(); return; }

        Promise.all(pair.map(function (u) {
          return fetch(u).then(function (r) {
            if (!r.ok) throw new Error(u);
            return r.blob();
          });
        })).then(function (blobs) {
          var readyCount = 0;
          var onReady = function () {
            if (++readyCount < 2) return;
            probeAlpha(vidF, function (ok) {
              if (!ok) { attempt(n + 1); return; }
              vidF.currentTime = CUES[0];
            });
          };
          [vidF, vidR].forEach(function (v, i) {
            v.addEventListener('loadeddata', onReady, { once: true });
            v.src = URL.createObjectURL(blobs[i]);
            v.load();
          });
        }).catch(function () {
          /* network failed for this encode — fall through to the next one */
          attempt(n + 1);
        });
      }

      attempt(0);
    }
    /* Gate on being able to play EITHER transparent encode — gating on VP9
       alone would send Safari straight to stills without trying the HEVC. */
    var canAnyEncode = vidF && vidF.canPlayType && (
      vidF.canPlayType('video/webm; codecs="vp9"') ||
      vidF.canPlayType('video/mp4; codecs="hvc1"')
    );
    if (REDUCED || !vidF || !vidR || !canAnyEncode || !window.fetch) {
      stillsMode();
    } else {
      bootVideos();
    }
    setMeta(0, false);

    /* hero add-to-cart uses the product currently on stage */
    if (heroAdd) {
      heroAdd.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(products[idx], heroAdd);
      });
    }
  }

  /* ======================================================================
     SCROLL REVEALS — split headlines + generic rise-ins
     ====================================================================== */
  $$('.pd-split').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var n = 0;
    words.forEach(function (word, wi) {
      var w = document.createElement('span');
      w.className = 'w';
      for (var i = 0; i < word.length; i++) {
        var ch = document.createElement('span');
        ch.className = 'ch';
        ch.style.setProperty('--i', n++);
        ch.textContent = word[i];
        w.appendChild(ch);
      }
      el.appendChild(w);
      if (wi < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  });

  /* after a split headline's rise finishes, mark it done so the letters
     settle to plain static text (no lingering per-letter animation state) */
  function settleSplit(el) {
    var n = el.querySelectorAll('.ch').length;
    setTimeout(function () { el.classList.add('is-done'); }, n * 26 + 950);
  }

  if ('IntersectionObserver' in window && !REDUCED) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          if (en.target.classList.contains('pd-split')) settleSplit(en.target);
          io.unobserve(en.target);
        }
      });
    }, { threshold: .18, rootMargin: '0px 0px -6% 0px' });
    $$('.pd-rev, .pd-split, .pd-anim').forEach(function (el) { io.observe(el); });
  } else {
    $$('.pd-rev, .pd-split, .pd-anim').forEach(function (el) {
      el.classList.add('is-in');
      if (el.classList.contains('pd-split')) el.classList.add('is-done');
    });
  }

  /* looping animations (band swirl, marquee, dash flows) only run while
     their section is actually on screen — offscreen they sit paused so
     they never steal frames from scrolling */
  var loopEls = $$('.pd-band, .pd-route, .pd-batches');
  if (loopEls.length) {
    if ('IntersectionObserver' in window) {
      var loopIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.classList.toggle('is-anim', en.isIntersecting);
        });
      }, { rootMargin: '60px 0px' });
      loopEls.forEach(function (el) { loopIO.observe(el); });
    } else {
      loopEls.forEach(function (el) { el.classList.add('is-anim'); });
    }
  }

  /* ======================================================================
     PRODUCT GRID add buttons
     ====================================================================== */
  $$('.pd-card__add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-product');
      var p = products.filter(function (x) { return x.key === key; })[0];
      addToCart(p, btn);
    });
  });

  /* ======================================================================
     MOBILE SWIPE CAROUSELS — the shop grid, review wall and testimonial
     stack become horizontal snap tracks under 760px (CSS). Dots are built
     here for every track; CSS hides them on desktop where the grids apply.
     ====================================================================== */
  $$('.pd-grid, .pd-rgrid, .pd-quotes').forEach(function (track) {
    var items = $$(':scope > *', track);
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'pd-dots';
    var btns = items.map(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1) + ' of ' + items.length);
      b.addEventListener('click', function () {
        track.scrollTo({
          left: item.offsetLeft - track.offsetLeft - (track.clientWidth - item.offsetWidth) / 2,
          behavior: REDUCED ? 'auto' : 'smooth'
        });
      });
      dots.appendChild(b);
      return b;
    });
    track.parentNode.insertBefore(dots, track.nextSibling);
    var tick = false;
    function mark() {
      tick = false;
      var c = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bd = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(item.offsetLeft - track.offsetLeft + item.offsetWidth / 2 - c);
        if (d < bd) { bd = d; best = i; }
      });
      btns.forEach(function (b, i) { b.classList.toggle('is-on', i === best); });
    }
    track.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(mark); }
    }, { passive: true });
    mark();
  });

  /* ======================================================================
     REVIEW CARD VIDEOS — poster until tapped, then plays with sound behind
     a scrub + mute bar that surfaces on hover. Only one runs at a time.
     ====================================================================== */
  var SPK_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4Zm11.5 3a3.5 3.5 0 0 0-2-3.15v6.3A3.5 3.5 0 0 0 15.5 12Zm-2 -7.3v2.06A5.5 5.5 0 0 1 13.5 17.24v2.06A7.5 7.5 0 0 0 13.5 4.7Z"/></svg>';
  var SPK_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4Zm16.7-.3-1.4-1.4L17 9.6l-2.3-2.3-1.4 1.4L15.6 11l-2.3 2.3 1.4 1.4L17 12.4l2.3 2.3 1.4-1.4L18.4 11l2.3-2.3Z"/></svg>';
  var rvids = [];

  function fmt(t) {
    if (!isFinite(t)) return '0:00';
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  $$('.pd-rcard__media').forEach(function (media) {
    var vid = $('video', media);
    var playBtn = $('.pd-rcard__play', media);
    if (!vid || !playBtn) return;

    /* control bar is built here so the two templates stay markup-light */
    var ctrl = document.createElement('div');
    ctrl.className = 'pd-rcard__ctrl';
    ctrl.innerHTML =
      '<button type="button" class="pd-rcard__mute" aria-label="Mute">' + SPK_ON + '</button>' +
      '<input type="range" class="pd-rcard__seek" min="0" max="1000" value="0" aria-label="Seek">' +
      '<span class="pd-rcard__time">0:00</span>';
    media.appendChild(ctrl);

    var mute = $('.pd-rcard__mute', ctrl);
    var seek = $('.pd-rcard__seek', ctrl);
    var time = $('.pd-rcard__time', ctrl);
    var scrubbing = false;

    rvids.push(vid);

    function paint() {
      var d = vid.duration;
      if (!isFinite(d) || !d) return;
      var p = vid.currentTime / d;
      if (!scrubbing) seek.value = String(Math.round(p * 1000));
      seek.style.setProperty('--p', (p * 100).toFixed(2) + '%');
      time.textContent = fmt(vid.currentTime);
    }

    function start() {
      rvids.forEach(function (o) { if (o !== vid && !o.paused) o.pause(); });
      vid.muted = false;
      media.classList.add('is-live', 'is-playing');
      vid.play();
    }

    playBtn.addEventListener('click', start);
    vid.addEventListener('click', function () {
      if (vid.paused) start(); else vid.pause();
    });

    vid.addEventListener('play', function () { media.classList.add('is-live', 'is-playing'); });
    vid.addEventListener('pause', function () { media.classList.remove('is-playing'); });
    vid.addEventListener('ended', function () {
      media.classList.remove('is-live', 'is-playing');
      vid.currentTime = 0;           /* frame 0 is the poster, so it reappears */
      seek.value = '0';
      seek.style.setProperty('--p', '0%');
      time.textContent = '0:00';
    });
    vid.addEventListener('timeupdate', paint);
    vid.addEventListener('loadedmetadata', paint);

    seek.addEventListener('pointerdown', function () { scrubbing = true; });
    seek.addEventListener('input', function () {
      var d = vid.duration;
      if (!isFinite(d) || !d) return;
      vid.currentTime = (seek.value / 1000) * d;
      seek.style.setProperty('--p', (seek.value / 10).toFixed(2) + '%');
      time.textContent = fmt(vid.currentTime);
    });
    seek.addEventListener('change', function () { scrubbing = false; });

    mute.addEventListener('click', function () {
      vid.muted = !vid.muted;
      mute.innerHTML = vid.muted ? SPK_OFF : SPK_ON;
      mute.setAttribute('aria-label', vid.muted ? 'Unmute' : 'Mute');
    });
  });

  /* magnetic CTA in the band */
  var mag = $('.pd-band .pd-btn');
  if (mag && FINE && !REDUCED) {
    var band = $('.pd-band');
    band.addEventListener('pointermove', function (e) {
      var r = mag.getBoundingClientRect();
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var dx = e.clientX - cx, dy = e.clientY - cy;
      var d = Math.hypot(dx, dy);
      if (d < 260) {
        var pull = (260 - d) / 260 * .35;
        mag.style.transform = 'translate(' + dx * pull + 'px,' + dy * pull + 'px)';
      } else mag.style.transform = '';
    });
    band.addEventListener('pointerleave', function () { mag.style.transform = ''; });
  }

  /* newsletter (demo locally, posts normally in Shopify) */
  var news = $('.pd-news');
  if (news && !news.getAttribute('action')) {
    news.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input', news);
      if (input && input.value.indexOf('@') > 0) {
        toast('<b>Subscribed.</b> Welcome to the list');
        input.value = '';
      } else toast('Enter a valid email');
    });
  }
})();
